"use strict";
var Observable_1 = require('../../Observable');
var delayWhen_1 = require('../../operator/delayWhen');
Observable_1.Observable.prototype.delayWhen = delayWhen_1.delayWhen;
//# sourceMappingURL=delayWhen.js.map


// WEBPACK FOOTER //
// ./techpad-upgrade/~/rxjs/add/operator/delayWhen.js